import { motion } from "framer-motion";
import { CalendarHeart, MessageCircle } from "lucide-react";
import { IMAGES } from "@/lib/api";

export default function EventsSection() {
  const scrollTo = (id) => document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="events" data-testid="events-section" className="relative py-24 md:py-32 bg-[#f7efe2] overflow-hidden grain">
      <img src={IMAGES.sound} alt="" className="absolute inset-0 w-full h-full object-cover opacity-10 pointer-events-none" />
      <div className="max-w-3xl mx-auto px-6 relative z-10 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <div className="w-16 h-16 rounded-full bg-[#e3b4b0]/40 flex items-center justify-center mx-auto mb-7">
            <CalendarHeart size={28} className="text-[#9c5560]" />
          </div>
          <p className="font-accent text-sm tracking-widest-2 uppercase text-[#c2a04b] mb-4">Events</p>
          <h2 className="font-display text-4xl md:text-5xl text-[#3a2630] leading-tight">
            Invite me to your gathering
          </h2>
          <p className="text-[#3a2630]/75 mt-6 leading-relaxed text-lg max-w-xl mx-auto">
            I would love to be part of upcoming events, ceremonies, and circles. If you are
            hosting something, message me — I'll happily come and share, completely free of charge.
          </p>

          <button
            data-testid="events-invite-btn"
            onClick={() => scrollTo("#contact")}
            className="mt-9 inline-flex items-center gap-2 font-accent tracking-wide px-8 py-3.5 rounded-full bg-[#b76e79] text-[#f7efe2] hover:bg-[#9c5560] transition-colors shadow-[0_10px_30px_rgba(156,85,96,0.22)]"
          >
            <MessageCircle size={19} /> Message me about your event
          </button>
        </motion.div>
      </div>
    </section>
  );
}
